/**
 * 参数管理工具类
 */

import {getMainChannelMobile, getMainChannelId} from '@/util/channelUtil'
import {fetchList} from '@/api/admin/sys-public-param'
import {getPublicValue} from '@/api/admin/user'

/**
 * 获取参数管理数据！！！
 * @param pubKey
 * @returns {Promise<*[]|string>}
 */
export function onGetFetchParamsData(pubKey) {
	return new Promise((resolve, reject) => {
		fetchList({descs: 'create_time', current: 1, size: 80})
			.then((resFetch = {}) => {
				let {records = []} = resFetch.data.data || {}
				let {publicValue = ''} =
					records.find(({publicKey = '', status = ''}) => publicKey === pubKey && status === '0') || {}
				resolve(publicValue)
			})
			.catch((error) => {
				reject(error)
			})
	})
}

/**
 * 获取允许投保一人
 * @param pubKey
 * @param insureTypeData
 * @returns {Promise<void>}
 */
export function onGetInsureAbleOne(pubKey, insureTypeData) {
	let isAble = false
	return new Promise(async (resolve) => {
		let channelMobile = getMainChannelMobile()
		let mainChannelId = getMainChannelId()
		if (channelMobile || mainChannelId) {
			let publicValue = await onGetFetchParamsData(pubKey)
			if (publicValue) {
				let tempValue = JSON.parse(publicValue) || []
				if (tempValue.length > 0) {
					let tempIndex = tempValue[0].value.findIndex(
						(itemData) => itemData === channelMobile || itemData === mainChannelId,
					)
					isAble = tempIndex !== -1
				}
				//手机号集合！！，获取主渠道手机号
				console.log(
					`获取允许投保一人---所有手机号：${tempValue[0].value}------主渠道：${channelMobile}--- ${mainChannelId}---${isAble}`,
				)
			}
		}
		resolve(isAble)
	})
}

/**
 * 获取升级公告
 * @returns {Promise<void>}
 */
export function onGetUpgradeNotice() {
	return new Promise(async (resolve) => {
		//如果不是渠道，则直接返回
		let publicValue = (await getPublicValue('TENANT_CLOSE_PNEW')) || {}
		let {code = 0, data = ''} = publicValue.data || {}
		if (code == 0 && data) {
			const {startTime = '', endTime = ''} = JSON.parse(data)
			if (!endTime || !startTime) {
				resolve(false)
			}

			//当前时间在时间范围内，则返回true
			if (new Date() > new Date(startTime) && new Date() < new Date(endTime)) {
				resolve(true)
			} else {
				resolve(false)
			}
		}
		resolve(false)
	})
}
